var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Status',{attrs:{"value":_vm.active,"ok-label":_vm.$t('rooms.active'),"ko-label":_vm.$t('rooms.deleted')}})}
var staticRenderFns = []

export { render, staticRenderFns }